var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDentistTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.05967V11.53H10.2H10.05V11.68V13.08V13.23H10.2H13.8H13.95V13.08V11.68V11.53H13.8H12.75V8.05967C14.1259 7.72262 15.15 6.47889 15.15 5C15.15 3.26316 13.7368 1.85 12 1.85C10.2632 1.85 8.85 3.26316 8.85 5C8.85 6.47889 9.87407 7.72262 11.25 8.05967Z",
    fill: "#4FC0CF",
    stroke: "#4FC0CF",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9492 15.28V15.13H13.7992H10.1992H10.0492V15.28V20.68C10.0492 21.7553 10.924 22.63 11.9992 22.63C13.0745 22.63 13.9492 21.7553 13.9492 20.68V15.28Z",
    fill: "#4FC0CF",
    stroke: "#4FC0CF",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9492 15.28V15.13H19.7992H16.1992H16.0492V15.28V20.68C16.0492 21.7553 16.924 22.63 17.9992 22.63C19.0745 22.63 19.9492 21.7553 19.9492 20.68V15.28Z",
    fill: "#4FC0CF",
    stroke: "#4FC0CF",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94922 15.28V15.13H7.79922H4.19922H4.04922V15.28V20.68C4.04922 21.7553 4.92398 22.63 5.99922 22.63C7.07446 22.63 7.94922 21.7553 7.94922 20.68V15.28Z",
    fill: "#4FC0CF",
    stroke: "#4FC0CF",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.85H2.85V2V3.2V3.35H3C4.24036 3.35 5.25 4.35964 5.25 5.6V11.53H4.2H4.05V11.68V13.08V13.23H4.2H7.8H7.95V13.08V11.68V11.53H7.8H6.75V5.6C6.75 3.53196 5.06804 1.85 3 1.85Z",
    fill: "#4FC0CF",
    stroke: "#4FC0CF",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1992 1.85H16.0492V2V3.2V3.35H16.1992H19.1992C19.4472 3.35 19.6492 3.55204 19.6492 3.8C19.6492 3.96976 19.6476 4.1553 19.5846 4.31621C19.5279 4.46092 19.419 4.59178 19.1801 4.65625H17.3992H17.2492V4.80625V11.53H16.1992H16.0492V11.68V13.08V13.23H16.1992H19.7992H19.9492V13.08V11.68V11.53H19.7992H18.7492V6.15H19.1992C19.7481 6.15 20.2369 5.87156 20.5847 5.47041C20.9323 5.06958 21.1493 4.53534 21.1493 4C21.1493 3.46466 20.9323 2.93042 20.5847 2.52959C20.2369 2.12844 19.7481 1.85 19.1992 1.85H16.1992Z",
    fill: "#4FC0CF",
    stroke: "#4FC0CF",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentistTools);
export default __webpack_public_path__ + "static/media/dentist-tools.29cdc2a98f216d3ab091260d6f3fa783.svg";
export { ForwardRef as ReactComponent };